<template>
  <div class="forgot-password-container" :class="containerWidth">
    <GauravImpexLogo class="justify-center" :variant="appLogoVariant" />
    <div class="description primary--text text-center mb-3">
      Forgot Password
    </div>
    <div v-if="!isEmailSent" class="section-1">
      <div class="mini-description text-center mb-3">
        Please enter your email ID and we will send you the reset link
      </div>
      <ValidationObserver @keydown.tab="focusNext" v-slot="{ passes }">
        <v-row>
          <v-col>
            <TextField
              v-model="email"
              showIcons
              rules="required|email"
              :loading="isForgotPasswordFormLoading"
              label="Email"
              placeholder="john.doe@gmail.com"
            />
          </v-col>
        </v-row>
        <v-btn
          large
          color="button-primary"
          class="white--text my-2"
          block
          :loading="isForgotPasswordFormLoading"
          @click="passes(forgotPassword)"
        >
          <span class="font-weight-bold fs-15">Send Reset Link</span>
        </v-btn>
      </ValidationObserver>
      <div class="text-center mt-3">
        <v-btn color="primary" text @click="$router.push({ name: 'auth.login' })">
          <v-icon left>fa-angle-left</v-icon>
          Go back
        </v-btn>
      </div>
    </div>
    <div v-else class="section-2 text-center mt-5">
      <v-card class="pa-3">
        We have sent a reset link to your email ID, please click your email to continue.
      </v-card>
      <v-btn @click="forgotPassword" :loading="isForgotPasswordFormLoading" color="primary" text class="mt-5">
        Resend Link
      </v-btn>
    </div>
  </div>
</template>
<script>
import GauravImpexLogo from "@/components/GauravImpexLogo";
import { ValidationObserver } from "vee-validate";
import TextField from "@/components/TextField";
import { FORGOT_PASSWORD } from "@/modules/AuthModule/store/actionTypes";
import commonMethodsMixin from "@/modules/commonMethodsMixin";
export default {
  name: "ForgotPassword",
  components: {
    GauravImpexLogo,
    ValidationObserver,
    TextField
  },
  data() {
    return {
      email: "",
      isForgotPasswordFormLoading: false,
      isEmailSent: false
    };
  },
  mixins: [commonMethodsMixin],
  methods: {
    forgotPassword() {
      this.isForgotPasswordFormLoading = true;
      this.$store
        .dispatch(FORGOT_PASSWORD, {
          email: this.email
        })
        .catch(err => {
          this.handleError(err);
          this.isEmailSent = false;
        })
        .then(res => {
          if (res && res.message === "success") {
            this.isEmailSent = true;
          }
        })
        .finally(() => {
          this.isForgotPasswordFormLoading = false;
        });
    }
  }
};
</script>
<style lang="scss">
.forgot-password-container {
  margin: auto;

  .description {
    font-size: 1.3rem;
    font-weight: 600;
  }

  .section-2 {
    .v-card {
      box-shadow: 0px 10px 40px rgba(0, 0, 0, 0.16);
    }
  }

  .form-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
</style>
